module.exports = __webpack_public_path__ + "img/danye3.bf3c911c.jpg";